import { LoadingSpinner, LoadingState } from "./styles";

type AccountLoaderProps = {
  label: string;
  fullPage?: boolean;
};

export function AccountLoader({ label, fullPage }: AccountLoaderProps) {
  return (
    <LoadingState $fullPage={fullPage} role="status" aria-live="polite">
      <LoadingSpinner aria-hidden="true" />
      <span>{label}</span>
    </LoadingState>
  );
}
